import * as React from "react";
import { ToggleFloatingLayer, DatePicker } from "@hubper/core-ui/components";
import { FloatingBox } from "@hubper/core-ui/elements";
import { months, days } from "@hubper/core-ui/components/DatePicker/constants";
import { useSelect } from "@hubper/theme";
import { format } from "date-fns";

import Field from "../components/Field";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  placeholder?: string;
  onChange: (value: any) => void;
  value: any;
  type: "single" | "range";
};

function DateFilter(
  { style, className, placeholder, onChange, value, type }: Props,
  ref: any
) {
  const { space } = useSelect();

  const fieldRef = React.useRef<HTMLDivElement>(null);

  React.useImperativeHandle(ref, () => ({
    focus: () => {
      fieldRef.current!.click();
    }
  }));

  let display = "";
  if (type === "range") {
    const start =
      value && value.start ? format(value.start, "DD-MM-YYYY") : "-";
    const end = value && value.end ? format(value.end, "DD-MM-YYYY") : "-";
    display = `${start} / ${end}`;
  } else {
    display = value ? format(value, "DD-MM-YYYY") : "-";
  }

  return (
    <>
      <ToggleFloatingLayer
        closeOnOutsideClick
        layer={
          <FloatingBox>
            <DatePicker
              style={{ margin: space(4) }}
              monthNames={months}
              dayNames={days}
              value={value}
              start={value && value.start}
              end={value && value.end}
              onChange={onChange}
              onRangeChange={(start, end) => onChange({ start, end })}
              range={type === "range"}
            />
          </FloatingBox>
        }
      >
        {({ isOpen, toggle }) => (
          <Field
            data-testid="date-filter"
            ref={fieldRef}
            isDropDown={false}
            style={style}
            className={className}
            isOpen={isOpen}
            onClick={toggle}
            placeholder={placeholder}
            value={display}
          />
        )}
      </ToggleFloatingLayer>
    </>
  );
}

export default React.forwardRef(DateFilter);
